import { Typography } from "@mui/material";
import { StepperNavBackgroundWrapper } from "./contact-header.style";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "../../../../components/button/button";
import { EditIcon } from "../../../../utils/svg-components";
import { useAuth } from "../../../../context/AuthContext";
import useCompany from "../../../../hooks/useCompany";
import { CircularIconButton } from "../../../../components/circular-button/circular-button.styles";

const ContactHeader = (props) => {
  const {
    isSaveEnabled,
    contactDetails,
    activeTab,
    isEditMode,
    setIsEditMode,
    isSaving,
    handleSave,
  } = props;

  const { userPermissions } = useAuth();

  const navigate = useNavigate();

  // Fetch company name based on contactDetails.companyID
  const {
    data: companyData,
    isLoading,
    isError,
  } = useCompany(contactDetails?.companyID);
  const companyName = isLoading
    ? "Loading..."
    : isError || !companyData
    ? "Unknown Company"
    : companyData?.companyName;

  return (
    <StepperNavBackgroundWrapper>
      <div className="flex">
        <CircularIconButton onClick={() => navigate("/contactsview")}>
          <ChevronLeft />
        </CircularIconButton>
        <div>
          <div className="head-flex">
            <Typography variant="h5">
              {contactDetails?.firstName} {contactDetails?.lastName}
            </Typography>
          </div>
          <div className="head-flex">
            <Typography variant="body3">
              {`ID: ${contactDetails?.id} `} | {`Company: ${companyName} `}
            </Typography>
          </div>
        </div>
      </div>
      <div>
        {activeTab === "basic-info" && (
          <div>
            {userPermissions !== "General" && !isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={() => setIsEditMode(true)}
                startIcon={<EditIcon />}
                sx={{ height: "33px" }}
              >
                Edit Contact
              </Button>
            )}

            {userPermissions !== "General" && isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={handleSave}
                startIcon={<EditIcon />}
                isLoading={isSaving}
                disabled={!isSaveEnabled}
              >
                Save Contact
              </Button>
            )}
          </div>
        )}
      </div>
    </StepperNavBackgroundWrapper>
  );
};

export default ContactHeader;
